/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionNotificationForTeamsWebHook extends models.ScheduleExecutionNotificationTeamsWebhook {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionNotificationForTeamsWebHook");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionNotificationForTeamsWebHook.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionNotificationForTeamsWebHook>): ScheduleExecutionNotificationForTeamsWebHook {
        let obj = Object.assign(new ScheduleExecutionNotificationForTeamsWebHook(), model);
        ScheduleExecutionNotificationForTeamsWebHook.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionNotificationForTeamsWebHook>): ScheduleExecutionNotificationForTeamsWebHook {
        if (!model) return null;
        return ScheduleExecutionNotificationForTeamsWebHook.newInstance(<ScheduleExecutionNotificationForTeamsWebHook> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionNotificationForTeamsWebHook) {
        if (!obj) return;

        models.ScheduleExecutionNotificationForTeamsWebHook.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionNotificationForTeamsWebHook): boolean {
        if (models.ScheduleExecutionNotificationTeamsWebhook.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionNotificationForTeamsWebHook.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
